/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind =
  ClosedEnum<
    typeof ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind
  >;

export type ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest =
  {
    ledgerCanisterId: string;
    offset?: number | undefined;
    limit?: number | undefined;
    maxTransactionIndex?: number | undefined;
    includeKind?:
      | Array<
        ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind
      >
      | undefined;
    start?: number | undefined;
    end?: number | undefined;
    /**
     * <I>Available values</I> : index, -index, amount, -amount, timestamp, -timestamp, kind, -kind
     */
    sortBy?: Array<string> | undefined;
  };

/** @internal */
export const ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind
  > = z.nativeEnum(
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind,
  );

/** @internal */
export const ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind
  > =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$ {
  /** @deprecated use `ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema;
  /** @deprecated use `ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema;
}

/** @internal */
export const ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema:
  z.ZodType<
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    max_transaction_index: z.number().int().optional(),
    include_kind: z.array(
      ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$inboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sort_by: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "max_transaction_index": "maxTransactionIndex",
      "include_kind": "includeKind",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    offset: number;
    limit: number;
    max_transaction_index?: number | undefined;
    include_kind?: Array<string> | undefined;
    start?: number | undefined;
    end?: number | undefined;
    sort_by?: Array<string> | undefined;
  };

/** @internal */
export const ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema:
  z.ZodType<
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$Outbound,
    z.ZodTypeDef,
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    offset: z.number().int().default(0),
    limit: z.number().int().default(20),
    maxTransactionIndex: z.number().int().optional(),
    includeKind: z.array(
      ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetIncludeKind$outboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sortBy: z.array(z.string()).optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      maxTransactionIndex: "max_transaction_index",
      includeKind: "include_kind",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$ {
  /** @deprecated use `ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema;
  /** @deprecated use `ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema;
  /** @deprecated use `ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$Outbound` instead. */
  export type Outbound =
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$Outbound;
}

export function listTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequestToJSON(
  listTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest:
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest,
): string {
  return JSON.stringify(
    ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$outboundSchema
      .parse(
        listTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest,
      ),
  );
}

export function listTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListTransactionsApiV1LedgersLedgerCanisterIdTransactionsGetRequest' from JSON`,
  );
}
